export const kn = {
    "TRIGGER_LISTEN": "ಟ್ರಿಗರ್ಸ್‌ಗಾಗಿ ಶ್ರವಣ,",
    "ASSIST_EMPTY_MSG": "ಏಜೆಂಟ್ ಎಐ ನಿಮ್ಮ ಸಂಭಾಷಣೆಯನ್ನು ಸಕ್ರಿಯವಾಗಿ ಕೇಳುತ್ತಿದೆ ಮತ್ತು ಟ್ರಿಗರ್ ಆಗಿದಾಗ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಸಹಾಯ ಮಾಡಲು ಸಿದ್ಧವಾಗಿದೆ.",
    "MYBOT_TRIGGET_LISTEN": "ಪ್ರಸ್ತುತ ಯಾವುದೇ ಸಕ್ರಿಯ ಮೈ ಬಾಟ್ ಟಾಸ್ಕ್ಗಳು ಇಲ್ಲ.",
    "MYBOT_EMTPY_MSG": "ಮೈ ಬಾಟ್‌ನಲ್ಲಿ ಟಾಸ್ಕ್ ಪ್ರಾರಂಭಿಸಲು, ಶೋಧ ಟ್ಯಾಬ್‌ಗೆ ಹೋಗಿ ಮತ್ತು ನಿಮ್ಮ ಇಚ್ಛಿತ ಟಾಸ್ಕ್‌ಗಾಗಿ \"\"ಏಜೆಂಟ್ ಇನ್‌ಪುಟ್‌ಗಳೊಂದಿಗೆ ರನ್\"\" ಆಯ್ಕೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "PROACTIVE_MODE": "ಪ್ರೊಆಕ್ಟಿವ್ ಮೋಡ್,",
    "SETTINGS": "ಸೆಟ್ಟಿಂಗ್ಗಳು,",
    "HELP_AND_SUPPORT": "ಸಹಾಯ ಮತ್ತು ಬೆಂಬಲ,",
    "HELP": "ಸಹಾಯ,",
    "LANGUAGE": "ಭಾಷೆ,",
    "THEME": "ಥೀಮ್,",
    "AUTOMATIC": "ಸ್ವಯಂಚಾಲಿತ,",
    "DARK": "ಕತ್ತಲೆ,",
    "FILE_NAME":"ಕಡತದ ಹೆಸರು",
    "AUTO_SCROLL_TOOLTIP":"ಸಹಾಯ ಟ್ಯಾಬ್, ನನ್ನ ಬಾಟ್ ಮತ್ತು ಲಿಪಿಯ ಟ್ಯಾಬ್ ವಿಷಯದ ಸ್ವಯಂಚಾಲಿತ ಸ್ಕ್ರೋಲಿಂಗ್ ಅನ್ನು ನಿಯಂತ್ರಿಸುತ್ತದೆ",
    "LIGHT": "ಬೆಳಕು,",
    "THEME_DESC": "ಇದು ನಿಮ್ಮ ಸಿಸ್ಟಮ್ ಡೀಫಾಲ್ಟ್ ಮೋಡ್ ಅನ್ನು ಬಳಸುತ್ತದೆ,",
    "DOCUMENTATION": "ದಸ್ತಾವೇಜು,",
    "DOC_DESC": "ನಮ್ಮ ವಿವರಣಾತ್ಮಕ ದಸ್ತಾವೇಜು ಲೇಖನಗಳನ್ನು ಪರಿಶೀಲಿಸಿ.",
    "FAQ_U": "ಎಫ್‌ಎಕ್ಯೂ,",
    "FAQ_DESC": "ಏಜೆಂಟ್ ಎಐ ಕುರಿತು વારಂવાર ಕೇಳುವ ಪ್ರಶ್ನೆಗಳನ್ನು ಪರಿಶೀಲಿಸಿ.",
    "KORE_ACADEMY": "ಕೋರ್ ಅಕಾಡೆಮಿ,",
    "KORE_ACA_DESC": "ಅಕಾಡೆಮಿ ಕೋರ್ಸ್‌ಗಳ ಮೂಲಕ ಹೋಗಿ ಏಜೆಂಟ್ ಎಐ ಬಗ್ಗೆ ಹೆಚ್ಚು ತಿಳಿದುಕೊಳ್ಳಿ.",
    "SEARCH": "ಹುಡುಕಿ,",
    "MY_BOT": "ನನ್ನ ಬಾಟ್,",
    "TAB_TEXT":"ಯಾವುದೇ ಟ್ಯಾಬ್ ಸಕ್ರಿಯಗೊಂಡಿಲ್ಲ! ದಯವಿಟ್ಟು ಕನಿಷ್ಠ ಒಂದು ಟ್ಯಾಬ್ ಸಕ್ರಿಯಗೊಳಿಸಿ",
    "ASSIST": "ಸಹಾಯ,",
    "TRANSCRIPT": "ಟ್ರಾನ್ಸ್ಕ್ರಿಪ್ಟ್,",
    "HISTORY": "ಇತಿಹಾಸ,",
    "TAP_SEARCH":"ಹುಡುಕಲು ಟ್ಯಾಪ್ ಮಾಡಿ",
    "STARTOVER": "ಮತ್ತೆ ಪ್ರಾರಂಭಿಸು,",
    "RESTART_INPUTS": "ಕ್ಯಾಪ್ಚರ್ ಮಾಡಲಾದ ಇನ್‌ಪುಟ್‌ಗಳೊಂದಿಗೆ ಪುನರಾರಂಭಿಸು,",
    "ASKCUSTOMER": "ಗ್ರಾಹಕರನ್ನು ಕೇಳಿ,",
    "TELLCUSTOMER": "ಗ್ರಾಹಕರಿಗೆ ಹೇಳಿ,",
    "WELCOME_MSG": "ಸ್ವಾಗತ ಸಂದೇಶ,",
    "SEND": "ಕಳುಹಿಸು,",
    "SENT": "ಕಳುಹಿಸಲಾಗಿದೆ,",
    "AWAITING": "ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ | ಮುಂದುವರಿಸಲು ಟೈಪ್ ಮಾಡಿ,",
    "OVERRIDE": "ಮುಂದುವರಿಸಲು ಟೈಪ್ ಮಾಡಿ,",
    "OVERRIDE_FILE": "ಮುಂದುವರಿಸಲು ಫೈಲ್ ಅಟಾಚ್ ಮಾಡಿ,",
    "ACCEPT_RESPONSE": "ಪ್ರತಿಕ್ರಿಯೆ ಸ್ವೀಕರಿಸಲಾಗಿದೆ,",
    "AGENT_ENTERED": "ಏಜೆಂಟ್ ಪ್ರವೇಶಿಸಿದನು,",
    "EXPECTED_FORMAT": "ಅನೂಕೂಲ ಸ್ವರೂಪ,",
    "INPUT_VALUES": "ಇನ್‌ಪುಟ್ ಮೌಲ್ಯಗಳು,",
    "RESTART": "ಪುನರಾರಂಭಿಸು,",
    "START_OVER": "ಮತ್ತೆ ಪ್ರಾರಂಭಿಸು,",
    "RESTART_CAPTURE": "ಕ್ಯಾಪ್ಚರ್ ಮಾಡಲಾದ ಇನ್‌ಪುಟ್‌ಗಳೊಂದಿಗೆ ಪುನರಾರಂಭಿಸು,",
    "CANCEL": "ರದ್ದುಮಾಡಿ,",
    "INTERRUPT_DIALOG": "ಅಡ್ಡಿಪಡಿಸಲಾದ ಡೈಲಾಗ್ ಟಾಸ್ಕ್,",
    "RUN": "ರನ್,",
    "RUN_AGENT": "ಏಜೆಂಟ್‌ನ ಇನ್‌ಪುಟ್‌ನೊಂದಿಗೆ ರನ್,",
    "STEP": "ಹೆಜ್ಜೆ,",
    "DIALOG_TASK": "ಡೈಲಾಗ್ ಟಾಸ್ಕ್,",
    "FAQ": "ಎಫ್‌ಎಕ್ಯೂ,",
    "SNIPPET": "ಉತ್ತರಗಳು,",
    "ARTICLE": "ವೆಬ್ ಪುಟಗಳು,",
    "FILE": "ಫೈಲ್‌ಗಳು,",
    "SUGGESTED": "ಸೂಚಿಸಲಾಗಿದೆ,",
    "ALL_DIALOG": "ಎಲ್ಲಾ ಡೈಲಾಗ್ ಟಾಸ್ಕ್‌ಗಳು,",
    "DIALOG_TEXT": "ಡೈಲಾಗ್,",
    "INTENT_IDENTIFIED": "ಗ್ರಾಹಕರ ಉಚ್ಛರಣೆ,",
    "NOT_WHAT_LOOKING": "ತಪ್ಪು ಸಲಹೆ?",
    "BOT": "ಬಾಟ್,",
    "CUSTOMER": "ಗ್ರಾಹಕ,",
    "YOU": "ನೀವು,",
    "TERMINATE_CONV": "ಡೈಲಾಗ್ ಟಾಸ್ಕ್ ಅನ್ನು ಮುಗಿಸಿ,",
    "TERMINATE_CONV_DESC": "ನೀವು ಡೈಲಾಗ್ ಟಾಸ್ಕ್ ಅನ್ನು ಮುಗಿಸಲು ಬಯಸುತ್ತೀರಾ? ಏಜೆಂಟ್ ಎಐ ಇನ್ನು ಮುಂದೆ ಸಲಹೆಗಳನ್ನು ನೀಡಲು ಸಾಧ್ಯವಾಗುವುದಿಲ್ಲ.",
    "YES_TERMINATE": "ಹೌದು, ಮುಗಿಸಿ,",
    "NO_CANCEL": "ಇಲ್ಲ, ರದ್ದುಮಾಡಿ,",
    "OVERRIDE_CONTINUE": "ಓವರ್ರೈಡ್ ಮೋಡ್‌ನೊಂದಿಗೆ ಮುಂದುವರಿಯಿರಿ,",
    "SUMMARY_TEXT": "ಸಾರಾಂಶ,",
    "SUBMIT": "ಸಲ್ಲಿಸಿ,",
    "INTERRUPT_OCCURED": "ವಿಚ್ಛಿನ್ನ ಸಂಭವಿಸಿದೆ,",
    "IDENTIFIED_INTENT": "ಗುರುತಿಸಲಾದ ಉದ್ದೇಶ,",
    "INTERRUPT_DESC": "ಇದನ್ನು ರನ್ ಮಾಡುವುದು ನಿಮ್ಮ ಮುಂದುವರಿದಿರುವ ಡೈಲಾಗ್ ಟಾಸ್ಕ್ ಅನ್ನು ಮುಗಿಸುತ್ತದೆ.",
    "ACCEPT_RUN": "ಸ್ವೀಕರಿಸಿ ಮತ್ತು ರನ್ ಮಾಡು,",
    "RUN_LATER": "ನಂತರ ರನ್ ಮಾಡು,",
    "KNOW_MORE": "ಹೆಚ್ಚು ತಿಳಿದುಕೊಳ್ಳಿ,",
    "MORE_TEXT": "ಹೆಚ್ಚು,",
    "LESS_TEXT": "ಕಡಿಮೆ,",
    "VIEW_MORE": "ಹೆಚ್ಚು ವೀಕ್ಷಿಸು,",
    "VIEW_LESS": "ಕಡಿಮೆ ವೀಕ್ಷಿಸು,",
    "SHOW_MORE_FAQ": "ಹೆಚ್ಚು ಎಫ್‌ಎಕ್ಯೂಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_LESS_FAQ": "ಕಡಿಮೆ ಎಫ್‌ಎಕ್ಯೂಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_MORE_ARTICLE": "ಹೆಚ್ಚು ವೆಬ್ ಪುಟಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_LESS_ARTICLE": "ಕಡಿಮೆ ವೆಬ್ ಪುಟಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_MORE_SNIPPET": "ಹೆಚ್ಚು ಉತ್ತರಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_LESS_SNIPPET": "ಕಡಿಮೆ ಉತ್ತರಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_MORE_FILES": "ಹೆಚ್ಚು ಫೈಲ್‌ಗಳನ್ನು ತೋರಿಸಿ,",
    "SHOW_LESS_FILES": "ಕಡಿಮೆ ಫೈಲ್‌ಗಳನ್ನು ತೋರಿಸಿ,",
    "VIEW_ALL_DIALOG": "ಎಲ್ಲಾ ಡೈಲಾಗ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ,",
    "VIEW_FEW_DIALOG": "ಕಡಿಮೆ ಡೈಲಾಗ್‌ಗಳನ್ನು ವೀಕ್ಷಿಸಿ,",
    "HELP_FULL": "ಉಪಯುಕ್ತವೇ?",
    "THANKYOU": "ಧನ್ಯವಾದಗಳು!",
    "EXPAND_MORE": "ವಿಸ್ತರಿಸು / ಹೆಚ್ಚು,",
    "CLOSE_TEXT": "ಮುಚ್ಚು,",
    "STARTED": "ಪ್ರಾರಂಭವಾಯಿತು,",
    "ENDED": "ಮುಗಿಯಿತು,",
    "VIEW_FULL_ARTICLE": "ವೆಬ್ ಪುಟ ವೀಕ್ಷಿಸು,",
    "VIEW_FULL_FILE": "ಫೈಲ್ ವೀಕ್ಷಿಸು,",
    "COPIED": "ನಕಲಿಸಲಾಗಿದೆ,",
    "SENTI_ANALY": "ಭಾವನಾತ್ಮಕ ವಿಶ್ಲೇಷಣೆ,",
    "WRONG_SUGGESTION": "ತಪ್ಪು ಸಲಹೆಗಳು,",
    "INCORRECT_INTENT": "ತಪ್ಪು ಉದ್ದೇಶ,",
    "ACCIDENTAL_CLICK": "ಅಕಸ್ಮಾತ್ ಕ್ಲಿಕ್,",
    "TIME_TAKING": "ಸಮಯ ಕಳೆಯುತ್ತಿದೆ,",
    "OTHER": "ಇತರೆ,",
    "PLAYBOOK_EMPTY_MSG": "ಪ್ಲೇಬುಕ್ ಆಯ್ಕೆಮಾಡಿ,",
    "PLAYBOOK_EMPTY_DESC": "ಎಲ್ಲಾ ಲಭ್ಯವಿರುವ ಪ್ಲೇಬುಕ್‌ಗಳು ಡೈನಾಮಿಕ್ ಆಗಿರುವುದರಿಂದ ಏಜೆಂಟ್ ಎಐ ಪ್ಲೇಬುಕ್ ಅನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ಪ್ಲೇಬುಕ್‌ ಗೆ ಪ್ರವೇಶ ಪಡೆಯಲು 'ಪ್ಲೇಬುಕ್ ಆಯ್ಕೆಮಾಡಿ' ಕ್ಲಿಕ್ ಮಾಡಿ,",
    "STAGE": "ಹಂತ,",
    "PROCEED_TO_CLOSE": "ಮುಚ್ಚಲು ಮುಂದುವರಿಸಿ,",
    "RECOMENDED_PLAYBOOK": "ಶಿಫಾರಸು ಮಾಡಲಾದ ಪ್ಲೇಬುಕ್,",
    "PRIMARY_SCRIPTS": "ಪ್ರಾಥಮಿಕ ಸ್ಕ್ರಿಪ್ಟ್‌ಗಳು,",
    "DYNAMIC_SCRIPTS": "ಡೈನಾಮಿಕ್ ಸ್ಕ್ರಿಪ್ಟ್‌ಗಳು,",
    "RESUME": "ಮತ್ತೆ ಪ್ರಾರಂಭಿಸು,",
    "ENABLE_CLOSE": "ಮುಚ್ಚುವ ಹಂತವನ್ನು ಸಕ್ರಿಯಗೊಳಿಸಲು ಮುಚ್ಚಲು ಮುಂದುವರಿಸಿ ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡಿ,",
    "LIST_VIEW": "ಪಟ್ಟಿ ವೀಕ್ಷಣೆ,",
    "TERMINATE": "ಮುಗಿಸಿ,",
    "MINIMIZE": "ಕಡಿಮೆ ಮಾಡು,",
    "MAXIMIZE": "ಅಧಿಕಗೊಳಿಸು,",
    "NO_SEARCH_RESULT": "ಯಾವುದೇ ಶೋಧ ಫಲಿತಾಂಶವಿಲ್ಲ,",
    "SENTIMENT_AWAITING": "ಭಾವನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ,",
    "POSITIVE": "ಧನಾತ್ಮಕ,",
    "NEGATIVE": "ನಕಾರಾತ್ಮಕ,",
    "ASSOCIATED_WORK_NOTES": "ಹಿಂದಿನ ಪರಿಹಾರದ ಟಿಪ್ಪಣಿಗಳು,",
    "AGENT_JOINED_CONV": "ಏಜೆಂಟ್ ಸಂಭಾಷಣೆಗೆ ಸೇರಿದ್ದಾನೆ,",
    "AUTOSCROLL_ASSIST": "ಆಟೋ-ಸ್ಕ್ರೋಲ್ ಅಸಿಸ್ಟ್ ಟ್ಯಾಬ್ ವಿಷಯ,",
    "FILE_SIZE_MSG": "ಫೈಲ್ ಗಾತ್ರ 25MB ಒಳಗಿರಬೇಕು. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    "OVERRIDE_BTN": "ಓವರ್ರೈಡ್,",
    "CHOOSE_FILE": "ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ,",
    "SUMMARY_ERROR_TEXT": "ಕ್ಷಮಿಸಿ, ಆದರೆ ಈ ಸಂಭಾಷಣೆಯ ಸಾರಾಂಶ ರಚಿಸುವಲ್ಲಿ ಒಂದು ಸಮಸ್ಯೆ ಇತ್ತು. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಸ್ವಂತ ಸಾರಾಂಶವನ್ನು ರಚಿಸಿ.",
    "ASK_A_QUESTION": "ಪ್ರಶ್ನೆ ಕೇಳಿ",
    "COPY" : "ಪ್ರತಿಯಾಗಿ",
    "PLAYBOOK": "ಪ್ಲೇಬುಕ್",
    "TELL_US_MORE": "ಇನ್ನಷ್ಟು ಹೇಳಿ",
    "THANKS_FEEDBACK": "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗೆ ಧನ್ಯವಾದಗಳು",
    "SOMETHING_WRONG": "ಊಹಿಸುವುದರಲ್ಲಿ ಏನಾದರೂ ತಪ್ಪಾಗಿದೆ",
    "CLICK_ERROR_DETAILS": "ದೋಷ ವಿವರಗಳನ್ನು ನೋಡಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    "NO_ACTIVE_PLAYBOOK": "ಸಕ್ರಿಯ ಪ್ಲೇಬುಕ್ ಇಲ್ಲ",
    "REPHRASE_QUESTION": "ನೀವು ನಿಮ್ಮ ಪ್ರಶ್ನೆಯನ್ನು ಪುನಾರೂಪಿಸಬಲ್ಲಿದೆಯಾ ಅಥವಾ ಇನ್ನೇನಾದರೂ ಕೇಳಬಹುದು?",
    "INTERNAL_INFO": "ಆಂತರಿಕ ಮಾಹಿತಿ",
    "SOURCES": "ಮೂಲಗಳು",
    "CONVERSATION_SUMMARY": "ಚರ್ಚೆಯ ಸಾರಾಂಶ",
    "WAITING": "ನೋಟಕ್ಕಾಗಿದ್ದೇನೆ",
    "WIDGET_DISABLED": "ವಿಜೆಟ್ ನಿಷ್ಕ್ರಿಯವಾಗಿದೆ",
    "AI_SETTINGS_DISABLED": "ಎಐ ಸೆಟಿಂಗ್ಸ್ ನಿಷ್ಕ್ರಿಯವಾಗಿದೆ! ದಯವಿಟ್ಟು ಎಐ ನಿರ್ವಾಹಕನನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "SERVER_CONNECTION_ERROR": "ಸರ್ವರ್ ಗೆ ಸಂಪರ್ಕ ಮಾಡುವಾಗ ದೋಷ",
    "VIEW": "ದೃಷ್ಟಿ",
    "ATTACHMENT_INPUT": "ಲಗತ್ತಿನ ಇನ್‌ಪುಟ್",
    "TYPE_SUMMARY": "ಸಾರಾಂಶವನ್ನು ಟೈಪ್ ಮಾಡಿ",
    "VIEW_FULL_ARTICLE_2": "ಮೂರ್ತಿಯ ಸಂಪೂರ್ಣ ಲೇಖನವನ್ನು ನೋಡಿ",
    "VIEW_FULL_FILE_2": "ಮೂರ್ತಿಯ ಸಂಪೂರ್ಣ ಫೈಲ್ ಅನ್ನು ನೋಡಿ",
    "BY":"ಮಾರ್ಗದರ್ಶಕ",
    GENERATE_SUMMARY: "ಸಾರಾಂಶವನ್ನು ರಚಿಸಿ",
    PREV_SUMMARIES: "ಹಿಂದೆ ರಚಿಸಿದ ಸಾರಾಂಶಗಳು",
    DIALOG_WORKFLOWS: "ಸಂವಾದ ಕಾರ್ಯಹರಿವುಗಳು",
    SHOW_ALL_DIALOG: "ಎಲ್ಲಾ ಸಂವಾದ ಕಾರ್ಯಗಳನ್ನು ತೋರಿಸಿ",
    SHOW_ALL_DIALOGS: "ಎಲ್ಲಾ ಸಂವಾದಗಳನ್ನು ತೋರಿಸಿ",
    CUSTOM_TAB: "ಕಸ್ಟಮ್ ಟ್ಯಾಬ್",
    AGENT_INPUT: "ಏಜೆಂಟ್ ಇನ್ಪುಟ್",
    "CUSTOM_EMPTY_MSG" : "ಸಕ್ರಿಯ ಕಾರ್ಯಹರಿವು ಇಲ್ಲ",
    "CUSTOM_TAB_DESC" : "ಒಂದು ಕಾರ್ಯಹರಿವನ್ನು ಪ್ರಾರಂಭಿಸಲು, ತಲೆಬಿಸ್ತಿರಿಸಿ ತೆರೆದ ಪಟ್ಟಿಯಿಂದ ಒಂದು ಕಾರ್ಯಹರಿವನ್ನು ಕಾರ್ಯಾಗಮಾಡಿ.",
    "SUBMIT_OVERALL_FEEDBACK" : "ಸಮಗ್ರ ಪ್ರತಿಕ್ರಿಯೆ ಸಲ್ಲಿಸಿ",
    "FEEDBACK_POPUP_SUBTITLE" : "ವಿಜೆಟ್ ಮತ್ತು ಇದರ ಸವಲತ್ತುಗಳ ಬಗ್ಗೆ ನಿಮ್ಮ ಅನುಭವ",
    "FEEDBACK_SATISFIED" : "ಸಂತೋಷವಾದ",
    "FEEDBACK_UNSATISFIED" : "ಸಂತೋಷವಾದ ಅಲ್ಲ",
    "FEEDBACK_PROVIDE_REASONS" : "ಹೆಚ್ಚಿನ ಮಾಹಿತಿ ನೀಡಿ…",
    "FEEDBACK_TITLE" : "ಪ್ರತಿಕ್ರಿಯೆ",
    "AGENTIC_THINKING" : "ಯೋಚಿಸುತ್ತಿದೆ",
    "AGENTIC_AGENT_TITLE" : "ಏಜೆಂಟ್",
    "AGENTIC_COPILOT_MODE_TITLE" : "ಏಜೆಂಟಿಕ್ ಕೋಪೈಲಟ್ ಮೋಡ್",
    "AGENTIC_SENDING_MESSAGE" : "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot ನಿಮ್ಮ ಸಂಭಾಷಣೆಯನ್ನು ಸಕ್ರಿಯವಾಗಿ ಕೇಳುತ್ತಿದೆ ಮತ್ತು ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಸಹಾಯ ಮಾಡಲು ಸಿದ್ಧವಾಗಿದೆ",
    "AGENTIC_SEARCH_RESULTS" : "ಏಜೆಂಟ್ ಫಲಿತಾಂಶಗಳು"
}